/** @jsxImportSource @emotion/react */
import { Button, Typography } from '@mui/material';
import logo from '../images/Logo_GLYNT_2020.png';
import { Link } from 'react-router';
import { css } from '@emotion/react';
import { useSetTitle } from '../components/hooks/useSetTitle';

const Page404 = () => {
  useSetTitle('404');
  return (
    <div>
      <div
        css={css`
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 2em;
        `}
      >
        <img src={logo} alt="logo" width={300} />
      </div>
      <Typography variant="h3" align="center">
        404: Page not found
      </Typography>
      <Typography variant="subtitle1" align="center">
        The requested URL doesn’t exist. Please check your URL
      </Typography>
      <div
        css={css`
          margin: 1em 0;
          width: 100%;
          display: flex;
          justify-content: center;
        `}
      >
        <Link
          to="/"
          css={css`
            text-decoration: none;
          `}
        >
          <Button variant="contained" color="primary">
            Home Page
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Page404;
